module.exports = __webpack_public_path__ + "static/media/17.03ccc4e7.jpg";